<template>
  <div class="pt-32 pb-20 px-6 max-w-4xl mx-auto">
    <div class="glass-card p-8 md:p-12 rounded-3xl border border-white/10 relative overflow-hidden text-gray-300">
      <!-- Glow effect -->
      <div class="absolute -top-24 -left-24 w-64 h-64 bg-fire-gold/10 blur-3xl rounded-full"></div>
      
      <h1 class="text-4xl md:text-5xl font-black mb-10 bg-gradient-to-r from-fire-gold via-white to-fire-gold bg-clip-text text-transparent italic">
        POLITIQUE DE CONFIDENTIALITÉ
      </h1>

      <p class="mb-12 text-lg text-white/80 border-l-4 border-fire-gold pl-6 italic">
        Découvrez comment Authentique Artifice utilise vos données pour améliorer votre expérience tout en respectant pleinement les lois européennes sur la protection des données (RGPD).
      </p>

      <div class="space-y-12">
        <section v-for="(section, index) in privacySections" :key="index" class="relative">
          <div class="flex items-start gap-4">
             <div class="w-12 h-12 rounded-xl bg-fire-gold/10 flex items-center justify-center text-fire-gold shrink-0 border border-fire-gold/20">
               <span class="text-xl font-black">{{ index + 1 }}</span>
             </div>
             <div>
               <h2 class="text-2xl font-bold text-white mb-4">{{ section.title }}</h2>
               <div v-html="section.content" class="space-y-4 leading-relaxed"></div>
             </div>
          </div>
        </section>
      </div>

      <div class="mt-16 p-8 rounded-3xl bg-fire-gold/5 border border-fire-gold/20 text-center">
        <h3 class="text-xl font-bold text-white mb-2 italic underline decoration-fire-gold/50">Besoin d'aide ?</h3>
        <p class="mb-4">Pour toute demande concernant vos données personnelles :</p>
        <a href="mailto:contact@authentiqueartifice.com" class="text-fire-gold font-bold text-lg hover:underline transition-all">
          contact@authentiqueartifice.com
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
const privacySections = [
  {
    title: "Nature des données collectées",
    content: `<p>Dans le cadre de l’utilisation de nos services, nous collectons deux catégories de données :</p>
              <ul class="list-disc pl-5 mt-2 space-y-1">
                <li><strong>Données d'identité :</strong> Nom, prénom, adresse de livraison, email.</li>
                <li><strong>Données techniques :</strong> Adresses IP, journaux de connexion et cookies techniques.</li>
              </ul>`
  },
  {
    title: "Gestion des Cookies",
    content: `<p>La durée maximale de conservation des cookies est de <strong>13 mois</strong>. Nous utilisons ces données à des fins statistiques pour optimiser votre navigation sur le site (mémoire du panier, personnalisation des pages).</p>`
  },
  {
    title: "Conservation et Anonymisation",
    content: `<p>Vos données sont conservées pendant la durée strictement nécessaire à la gestion de la relation commerciale. Si vous restez inactif pendant une période de <strong>3 ans</strong>, vos données personnelles seront supprimées de nos bases conformément aux recommandations de la CNIL.</p>`
  },
  {
    title: "Sécurité et Faille de Données",
    content: `<p>Nous mettons en œuvre toutes les mesures techniques pour garantir un niveau de sécurité maximal. En cas d'accès non autorisé à vos données, nous nous engageons à vous notifier l’incident dans les plus brefs délais et à prendre les mesures nécessaires pour limiter les préjudices.</p>`
  },
  {
    title: "Vos Droits",
    content: `<p>Conformément à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et surtout de <strong>droit à l'oubli</strong>. Vous pouvez supprimer votre compte à tout moment depuis vos paramètres ou par simple demande par email.</p>`
  }
];
</script>

<style scoped>
.glass-card {
  background: rgba(10, 10, 15, 0.8);
  backdrop-filter: blur(25px);
}
</style>
